export const sessionExpiredEvent = "cache-river:session-expired";

export function createSessionBoundary() {
  let epoch = 0;
  return {
    current: () => epoch,
    changed: () => ++epoch,
    shouldExpire(path: string, status: number, started: number) {
      const route = path.split("?")[0]!;
      const authenticated =
        /^\/(admin|customer|tickets|voice)(\/|$)/.test(route) ||
        ["/logout", "/change-password", "/customer-view/exit"].includes(route);
      return status === 401 && authenticated && started === epoch;
    },
  };
}

export const sessionBoundary = createSessionBoundary();
